const DITypes = {
  SocketConnection: Symbol('FinsightSocketConnection'),
  SocketAdapter: Symbol('FinsightSocketAdapter'),
  SocketDispatcherFactory: Symbol('FinsightSocketDispatcherFactory'),
  SocketClient: Symbol('FinsightSocketClient'),
  SocketDispatcher: Symbol('FinsightSocketDispatcher'),
};

export default DITypes;
